module.exports = __webpack_public_path__ + "img/title.0db6df96.png";